import { formatMoney } from '@betterment/core';
import { Box, Separator, Text } from '@betterment/samba-react';
import { ActivityDrawerLayout } from '@betterment/shared-components/src/components/activity/components/drawer/common/ActivityDrawerLayout';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';
import { useFallbackKeys } from '@betterment/shared-components/src/hooks/useFallbackKeys';

import { ActivityItemFragment } from '../../../../graphql/fragments/activityItem.generated';
import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';
import { DividendPayout } from '../common/trades/DividendPayout';

type DividendGroup = NarrowTypename<ActivityItemFragment, 'ActivityItemDividendGroup'>;
export type DividendItem = DividendGroup['dividends'][number];

export const Dividend: React.FC<{
  item: DividendGroup;
}> = ({ item }) => {
  const dividends = useFallbackKeys(item.dividends || []);
  return (
    <ActivityDrawerLayout title="Dividend payment">
      <DrawerListRow label="Account" value={item.subAccount?.name} />
      <Separator />
      <DrawerListRow label="Amount" value={formatMoney(item.dividendAmount)} />
      <Separator />
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.300', py: 'space.200' }}>
        <Text variant="text100">Dividends from</Text>
        {dividends?.map((dividend, key) => <DividendPayout key={key} item={dividend.item} />)}
      </Box>
    </ActivityDrawerLayout>
  );
};
